<template>
  <hgroup>
    <h2 class="text-lg font-medium text-gray-900 mb-0">
      <slot name="title" />
    </h2>
    <p class="text-sm text-gray-700 mb-0">
      <slot name="sub-title" />
    </p>
  </hgroup>
</template>
